import React from 'react'
import Helmet from 'react-helmet'
import styled, { css } from 'styled-components'
import { Header, Footer, FooterBlock, ScrollBackground, Splash } from '../components'

import '../styles/global'
import { headerHeight } from '../styles/global'
import { media } from '../styles/utils'

const Layout = ({ children, data, location }) => (
	<SiteWrapper
        id={'site-wrapper'}
    >
	
    	<Helmet
            title={data.site.siteMetadata.title}
            
			meta={[
				{ name: 'description', content: data.wordpressOptions.meta_description_default},
                { name: 'keywords', content: data.site.siteMetadata.keywords },
                { property: 'og:url', content: data.site.siteMetadata.url },
                //{ property: 'og:image', content: ogProfileImage },
                { property: 'og:title', content: data.site.siteMetadata.title },
                { property: 'og:description', content: data.wordpressOptions.meta_description_default},
                { property: 'twitter:card', content: 'summary' },
                { property: 'twitter:title', content: data.site.siteMetadata.title },
                { property: 'twitter:description', content: data.wordpressOptions.meta_description_default}
            ]}
		/>

        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover"/>
            <meta name="facebook-domain-verification" content="0koso2adnmg0mzt3wu58a4iugp6zce"/>
            <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
            <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
            <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.11.1/TweenLite.min.js"/>
            <meta name="google-site-verification" content="cMtKnIO9mU5X2m766CxIQahSYnkajwMfvACnieAcZes" />
            <meta name="google-site-verification" content="046E-7clONn2iajBlvtwCVxmViCI2dIkXuQpwy2iRbI" />
        </Helmet>

        <ScrollBackground
            location={location}
        />

        {/* First-visit intro/loading overlay — disabled on request.
            Uncomment to bring it back; the Splash component itself is unchanged. */}
        {/* <Splash
            homeAcfJson={data.wordpressHome && data.wordpressHome.acf_json}
        /> */}

        <Header
            location={location}
        />

        {children()}

        {(() => {
            // Site-wide footer, skipped entirely on /contact because that page
            // already has the same contact info + subscribe form at the top.
            const path = (location && location.pathname) || '';
            const isContact = path.indexOf('/contact') === 0;
            if (isContact) return null;
            return <FooterBlock />;
        })()}

  </SiteWrapper>
)

const SiteWrapper = styled.div`
    height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
    padding-top: ${headerHeight.desktop}px;

    > *:first-child {
        transition: background-color 0.1s ease-out;
    }

	${media.laptop`
		padding-top: ${headerHeight.laptop}px;
	`}

	${media.phone`
		padding-top: ${headerHeight.phone}px;
	`}
`

export default Layout

export const query = graphql`
	query SiteTitleQuery {
		site {
			siteMetadata {
                title,
                description,
                keywords,
                url
			}
		}
        wordpressOptions {
            meta_description_default
        }
        wordpressHome {
            acf_json
        }
	}
`



// WEBPACK FOOTER //
// ./src/layouts/index.js